export interface StripeProduct {
  id: string;
  name: string;
  priceId: string;
  price: number;
  interval: 'month' | 'year';
  features: string[];
  optimizations: number;
}

export const stripeProducts: StripeProduct[] = [
  {
    id: 'starter',
    name: 'Starter',
    priceId: import.meta.env.VITE_STRIPE_PRICE_ID_STARTER || 'price_starter',
    price: 5.99,
    interval: 'month',
    optimizations: 30,
    features: [
      '30 optimizations per month',
      'AI-powered optimization',
      'ATS compatibility check',
      'All formats (TXT, PDF, DOCX)',
      'Priority email support',
      'Keyword optimization',
      'Professional formatting',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    priceId: import.meta.env.VITE_STRIPE_PRICE_ID_PRO || 'price_pro',
    price: 19.99,
    interval: 'month',
    optimizations: 150,
    features: [
      '150 optimizations per month',
      'AI-powered optimization',
      'ATS compatibility check',
      'All formats (TXT, PDF, DOCX)',
      'Priority support',
      'Advanced keyword optimization',
      'Professional formatting',
      'Custom templates',
      'Bulk processing',
    ],
  },
];
